import { useParams } from 'react-router';

import { HelpDrawer } from '../../components/ReferenceBar/HelpDrawer/HelpDrawer.tsx';
import { PageID } from '../../components/ReferenceBar/HelpDrawer/types.ts';

export const PageGuidePopoutRouteElement = () => {
  const { pageID = null } = useParams<{ pageID: PageID }>();
  return <HelpDrawer pageID={pageID} isPopout />;
};
